export default __webpack_public_path__ + "static/media/intro4.d745f60b.png";